<template>
  <div class="vue-friendly-iframe">
  </div>
</template>

<script>
import { v1 as uuidV1 } from 'uuid';
import utils from './utils';

function generateGuid() {
  return uuidV1();
}

const eventAddMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
const eventRemoveMethod = window.addEventListener ? 'removeEventListener' : 'detachEvent';
const eventListenerAdd = window[eventAddMethod];
const messageEvent = eventAddMethod === 'attachEvent' ? 'onmessage' : 'message';
const eventListenerRemove = window[eventRemoveMethod];

/**
 * Friendly iframe improved
 */
export default {
  name: 'friendly-iframe',
  props: {
    src: {
      type: String,
      required: true
    },
    crossorigin: {
      type: String,
      required: false,
      default: 'anonymous'
    },
    sandbox: {
      type: String,
      required: false,
      default: ''
    },
    target: {
      type: String,
      required: false,
      default: '_parent'
    },
    className: {
      type: String,
      required: false
    },
    allow: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      iframeEl: null,
      iframeLoadedMessage: `IFRAME_LOADED_${generateGuid()}`,
      iframeOnReadyStateChangeMessage: `IFRAME_ON_READ_STATE_CHANGE_${generateGuid()}`
    };
  },
  computed: {},
  watch: {
    src() {
      this.reinitIframe(this);
    }
  },
  methods: {
    removeIframe() {
      while (this.$el.firstChild) {
        this.$el.removeChild(this.$el.firstChild);
      }
    },
    setIframeUrl() {
      const iframeDoc = this.iframeEl.contentWindow.document;
      iframeDoc.open()
          .write(
              `
          <body onload="window.location.replace('${this.src}'); parent.postMessage('${this.iframeLoadedMessage}', '*')"></body>
          <script>
            window.document.onreadystatechange = function () {
              if (window.document.readyState === 'complete') {
                parent.postMessage('${this.iframeOnReadyStateChangeMessage}', '*')
              }
            };
          <\/script>
          `
          );
      iframeDoc.close(); //iframe onload event happens
    },
    reinitIframe: utils.debounce(vm => {
      vm.removeIframe();
      vm.initIframe();
    }, 200),
    initIframe() {
      this.iframeEl = document.createElement('iframe');
      this.iframeEl.setAttribute('style', 'visibility: hidden; position: absolute; top: -99999px; border: none;');
      if (this.src) this.iframeEl.setAttribute('iframe-src', this.src);
      if (this.className) this.iframeEl.setAttribute('class', this.className);
      if (this.class) this.iframeEl.setAttribute('class', this.class);
      // if (this.crossorigin) this.iframeEl.setAttribute('crossorigin', this.crossorigin);
      // if (this.sandbox !== '')this.iframeEl.setAttribute('sandbox', this.sandbox);
      if (this.target) this.iframeEl.setAttribute('target', this.target);
      if (this.allow) this.iframeEl.setAttribute('allow', this.allow);
      if (this.name) this.iframeEl.setAttribute('name', this.name);
      this.$el.appendChild(this.iframeEl);
      this.setIframeUrl();
    },
    listenForEvents() {
      // Create IE + others compatible event handler
      this.f = event => {
        // console.log(messageEvent)
        // console.log(event);

        if (event && event.data && event.data === this.iframeLoadedMessage) {
          // console.log("IFRAME_LOAD")
          this.$emit('iframe-load');
          this.iframeEl.setAttribute('style', 'visibility: visible; border: none;');
        }
        if (event && event.data && event.data === this.iframeOnReadyStateChangeMessage) {
          // console.log("IFRAME_READYSTATE")
          this.$emit('load');
        }
        let data;
        try {
          data = JSON.parse(event.data).data;
          if (data && data.url) {
            this.$emit('urlEvent', data.url);
          }
        } catch (e) {

        }
        // console.log("data:",data);
      };

      eventListenerAdd(messageEvent, this.f, false);
      console.log("Called listenForEvents on ", this);
    },
    unListenForEvents() {
      eventListenerRemove(messageEvent, this.f)
    },
  },
  mounted() {
    this.listenForEvents();
    this.initIframe();
  },
  beforeDestroy() {
    this.unListenForEvents();
  }
};
</script>
